import styled from 'styled-components';
import loading from '../../img/loading.svg';

const LoadingSubscription = styled.div`
	background: ${({ theme }) => theme.backgroundLoading};
	background-size: 130px auto;
	position: fixed;
	height: 100%;
	width: 100%;
	top: 0;
	left: 0;
	z-index: 9999999999;
	display: flex;
	align-items: center;
	justify-content: center;

	.loading-image {
		background: url(${loading})
			no-repeat center;
		background-size: 130px auto;
		position: fixed;
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		z-index: 9999999999;
		display: flex;
		align-items: center;
		justify-content: center;
		filter: ${({ theme }) => theme.colorFilterImgLoading};
	}

	.loading-text {
		text-align: center;
		color: ${({ theme }) => theme.colorTextLoading};
		font-family: ${({ theme }) => theme.fontFamilyTextLoading};
		font-weight: ${({ theme }) => theme.fontWeightTextLoading};
		font-size: 2rem;
		margin-top: 150px;
	}
`;

export default LoadingSubscription;
